import { GraphQLInt, GraphQLString, GraphQLNonNull, GraphQLBoolean } from 'graphql';
import { mutationWithClientMutationId } from 'graphql-relay';
import uuid from 'uuid';
import AssetTypeEnum from 'appConsts/AssetType';

import getFieldsFromOffer from 'helper/LearningSpaceServices/TransformationHelpers/getFieldsFromOffer';
import getFieldOneCard from 'helper/LearningSpaceServices/TransformationHelpers/getFieldOneCard';
import getCardFromOffer from 'helper/LearningSpaceServices/TransformationHelpers/getCardFromOffer';
import { getContentDetailsByContentId } from 'helper/LearningSpaceServices/LocalStore';
import User from 'helper/currentUser';
import { CommandTypeEnum } from 'appConsts';

import mutationSync from '../helpers/mutationSync';
import formatAnswerForCommand from '../helpers/formatAnswerForCommand';
import CardType from '../gqlTypes/card.gql';
import CardPerformance from '../gqlTypes/cardPerformance.gql';
import CoursePerformance from '../gqlTypes/coursePerformance.gql';
import AnswerType from '../gqlTypes/answer.gql';
import CourseType from '../gqlTypes/course.gql';

const user = new User();

module.exports = mutationWithClientMutationId({
  name: 'PerQuestionSubmission',
  inputFields: {
    cardId: {
      type: GraphQLString
    },
    answerObject: {
      type: new GraphQLNonNull(AnswerType)
    },
    time: {
      type: GraphQLInt
    },
    userId: {
      type: GraphQLString
    },
    timeStamp: {
      type: GraphQLString
    },
    rootOfferId: {
      type: GraphQLString
    },
    actualSubmit: {
      type: GraphQLBoolean
    },
    checkAnswersAttemptCount: {
      type: GraphQLInt
    },
    flagged: {
      type: GraphQLBoolean
    }
  },
  outputFields: {
    card: {
      type: CardType,
      resolve: payload => payload.card
    },
    cardPerformance: {
      type: CardPerformance
    },
    coursePerformance: {
      type: CoursePerformance
    },
    course: {
      type: CourseType
    }
  },
  mutateAndGetPayload: params => new Promise(async (resolve) => {
    const {
      cardId: contentId,
      userId,
      rootOfferId: courseId,
      answerObject: answer,
      actualSubmit,
      checkAnswersAttemptCount,
      flagged
    } = params;

    const command = {
      id: uuid(),
      type: CommandTypeEnum.PER_QUESTION_SUBMISSION,
      contentId,
      userId,
      answer: formatAnswerForCommand(answer),
      actualSubmit,
      creatorId: userId,
      timeStamp: new Date().toISOString(),
      rootContentId: courseId,
      checkAnswersAttemptCount,
      flagged
    };

    const { offer, updatedStates, stateInteractions } = await mutationSync({
      offerId: courseId,
      offerType: AssetTypeEnum.offer,
      userObject: {
        userId,
        companyId: user.companyId()
      },
      command
    });

    const coursePerformance = getFieldsFromOffer(offer, updatedStates).coursePerformance;
    const contentDetails = await getContentDetailsByContentId(courseId);
    const card = getFieldOneCard(
      offer,
      contentDetails,
      getCardFromOffer(contentId, offer),
      updatedStates,
      stateInteractions
    );
    const cardPerformance = card.performance;

    resolve({ coursePerformance, cardPerformance, course: offer, card });
  })
});
